// src/reducers/warehouseReducer.js

import { types } from '../types/types';

const initialState = {
    editingWarehouse: {
        id: 0,
        name: '',
        realmFk: '',
        measurementUnit: '',
        productFk: 0,
        productName: '',
        quantity: 0,
        status: true,
    }
};

export const warehouseReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingWarehouseInfo:
            return {
                ...state,
                editingWarehouse: action.payload
            };

        case types.clearWarehouseInfo:
            return {
                ...state,
                editingWarehouse: initialState.editingWarehouse
            };

        default:
            return state;
    }
};